import React from "react";
import { Terminal, GameController, Cpu, SpeakerHigh } from "@phosphor-icons/react";
import { GhosttyTerminal } from "../arcade/GhosttyTerminal";
import { arcadeContent } from "../../data/content";

export const ArcadeSection: React.FC = () => {
  const featureIcons = [
    <GameController size={16} key="controller" />,
    <SpeakerHigh size={16} key="speaker" />,
    <Cpu size={16} key="cpu" />,
  ];

  return (
    <section id="ai-stuff" className="py-20 sm:py-24 border-b border-[#242320] scroll-mt-20 sm:scroll-mt-24">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        {/* Stacked Left-Aligned Header */}
        <div className="mb-10 sm:mb-12 text-left">
          <div className="flex items-center gap-2 mb-2">
            <Terminal className="w-4 h-4 text-[#E5983A]" weight="bold" />
            <span className="text-xs font-mono uppercase tracking-widest text-[#E5983A]">
              {arcadeContent.sectionTag}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold font-display tracking-tight text-[#F3F2EE] mb-2.5">
            {arcadeContent.title}
          </h2>
          <p className="text-sm font-mono text-[#8C8A84] max-w-xl">
            {arcadeContent.subtitle}
          </p>
        </div>

        {/* Ghostty Terminal Arcade Frame */}
        <div className="mb-8">
          <GhosttyTerminal />
        </div>

        {/* Technical Specs Footer */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
          {arcadeContent.features.map((feature, idx) => (
            <div key={idx} className="p-4 rounded-xl bg-[#181716] border border-[#262522] flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-[#22211F] border border-[#2D2B27] flex items-center justify-center text-[#E5983A] shrink-0">
                {featureIcons[idx % featureIcons.length]}
              </div>
              <div>
                <p className="text-xs font-mono font-bold text-[#F3F2EE]">{feature.title}</p>
                <p className="text-[11px] font-mono text-[#8C8A84]">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
